import React from "react";

const DailyBeatPlanGTV = ({ data }) => {
    if (!data) return null;

    return (
        <div className="spd-table-container">
            <h4 className="mb-3">Daily Beat Plan GTV Report</h4>

            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>IC Name</th>
                            <th>Manager Name</th>
                            <th>#Stores Allocated<br />As Per Beat Plan (MTD)</th>
                            <th>#Stores Visited As Per Beat Plan<br />Doing T-1 GTV &gt; Rs. 25,000</th>
                            <th>#Stores Visited As Per Beat Plan<br />Doing WTD GTV &gt; Rs. 25,000</th>
                            <th>#Stores Visited As Per Beat Plan<br />Doing MTD GTV &gt; Rs. 25,000</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((row, idx) => (
                            <tr key={idx}>
                                <td><strong>{row.icName}</strong></td>
                                <td>{row.managerName}</td>
                                <td className="text-center">{row.storesAllocated || '-'}</td>
                                <td className="text-center">{row.storesVisitedT1 || '-'}</td>
                                <td className="text-center">{row.storesVisitedWTD || '-'}</td>
                                <td className="text-center">{row.storesVisitedMTD || '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DailyBeatPlanGTV;
